import { Color } from 'zens-storybook'

export const HEATMAP_COLORS = [
  '#EDF7FF', // 0-10 %
  Color.lightGreyBlue, // 10-20 %
  Color.lightGreyBlue, // 20-30 %
  Color.greyBlue, // 30-40 %
  Color.greyBlue, // 40-50 %
  Color.darkGreyBlue, // 50-60 %
  Color.darkGreyBlue, // 60-70 %
  Color.darkerBlue, // 70-80 %
  Color.darkerBlue, // 80-90 %
  '#102E47', // 90-100 %
]
export const heatmapColor = (occupancy: number) => {
  const colorIndex = Math.max(0, Math.min(9, Math.floor(occupancy / 10)))
  return HEATMAP_COLORS[colorIndex]
}
